<template>
  <div class="flex w-full h-[100vh] bg-white">
    <!-- logo -->
    <div class="fixed flex w-fit mt-[33px] top-0 left-0 right-0 m-auto">
      <img
          alt="Logo Mishnat"
          class="w-[121px] h-[50px] cursor-pointer"
          src="/src/assets/icons/logos/logo-login.svg"
          @click="$router.push('/')"
      />
    </div>
    <!-- content -->
    <div
        class="flex flex-col gap-[36px] h-fit w-fit m-auto max-w-[470px] text-center"
    >
      <!-- texts -->
      <section class="flex flex-col gap-[12px]">
        <h1 class="text-primary-700 text-3xl font-bold">
          אויש. לא הולך לנו :(
        </h1>
        <p class="text-grays-900 text-lg font-regular">
          זה קורה במשפחות הכי טובות כנראה נגמר תוקף הקישור או שיש בעיה אחרת,
          כדאי לנסות שוב. אם הבעיה נמשכת, דברו עם צוות התמיכה שלנו
        </p>
      </section>
      <!-- action -->
      <section class="flex flex-col items-center gap-[4px]">
        <button-primary :disabled="!!timer" @click="resendEmailVerification"
        >תשלחו לי שוב קישור
        </button-primary
        >
        <div class="min-h-[22px] min-w-[10px]">
          <div v-if="timer">
            <span class="font-regular">נסו שוב בעוד {{ timer }}s</span>
          </div>
        </div>
        <p class="text-grays-900 text-base font-regular">
          דברו איתנו 074589-356
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import axiosInstance from "@/helpers/axios";
import {mapGetters} from "vuex";

export default {
  name: "email-verification-unsuccessful",
  components: {ButtonPrimary},
  data() {
    return {
      timer: 0,
    };
  },
  methods: {
    startTimer() {
      this.timer = 60;
      const timer = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    async resendEmailVerification() {
      this.isLoading = true;
      try {
        localStorage.setItem("token", this.token);
        await axiosInstance.get("/sendEmailVerificationLink");
        localStorage.removeItem("token");
      } catch (e) {
        this.errors = true;
      } finally {
        this.isLoading = false;
      }
      this.startTimer();
    },
  },
  computed: {
    ...mapGetters({
      token: "user/getToken",
    }),
  },
};
</script>

<style>
</style>